import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useOnlyTLReadAccess } from "./useOnlyTLReadAccess";

const tlPath = "/traffic-buoys";
export function useTrafficBuoyRedirect() {
  const history = useHistory();
  const location = useLocation();
  const onlyTLReadAccess = useOnlyTLReadAccess();

  React.useEffect(() => {
    if (onlyTLReadAccess && location.pathname !== tlPath) {
      history.push(tlPath);
    }
  }, [history, location.pathname, onlyTLReadAccess]);
}
